import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/settings/_access/users/$userId/')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/settings/users/$userId/$tab',
      params: { organizationName: params.organizationName, userId: params.userId, tab: 'overview' },
    });
  },
});
